import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  userList: [],
  adminList: [],
  teacherList: [],
  collegeList: [],
  classList: [],
}

export const getters = {}

export const mutations = {
  CACHE_USER_LIST(state, newList) {
    state.userList = newList
  },
  CACHE_ADMIN_LIST(state, newList) {
    state.adminList = newList
  },
  CACHE_TEACHER_LIST(state, newList) {
    state.teacherList = newList
  },
  CACHE_COLLEGE_LIST(state, newList) {
    state.collegeList = newList
  },
  CACHE_CLASS_LIST(state, newList) {
    state.classList = newList
  },
}

export const actions = {
  fetchUserList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/users?role=user&${arrayToQueryString(filter)}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_USER_LIST', list)
        return list
      })
  },
  fetchAdminList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/users/admin?&${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_ADMIN_LIST', list)
        return list
      })
  },
  addUser({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/inviteregister`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  updateUser({ commit, state, rootState }, { Data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/users/${Data.id}`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  deleteUser({ commit, state, rootState }, { userData }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/users/${userData.id}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },

  fetchCollegeList({ commit, state, rootState }) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/college/all`)
      .then((response) => {
        const data = response.data
        const list = {}
        commit('CACHE_COLLEGE_LIST', list)
        return data
      })
  },
  fetchClassList({ commit, state, rootState }) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/college-class/all`)
      .then((response) => {
        const data = response.data
        const list = {}
        commit('CACHE_CLASS_LIST', list)
        return data
      })
  },
  fetchTeacherList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/users/teacher?&${arrayToQueryString(filter)}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_TEACHER_LIST', list)
        return list
      })
  },
  fetchTrainerList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/trainer?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_USER_LIST', list)
        return list
      })
  },
  getZoomUsers({ commit, state, rootState }) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/users/zoom-users`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
}
